module.exports = __webpack_public_path__ + "img/9788992263153.32dd38b6.jpg";